import React from 'react';
import { classes } from './form-styles.st.css';
export const FormStyles = ({ children, enabled })=>{
    if (!enabled) {
        return /*#__PURE__*/ React.createElement("div", null, children);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classes.formStyles
    }, children);
};

//# sourceMappingURL=form-styles.js.map